import component from './CombiInterest.vue';
import { StepCategoryId, StepId } from '~/consts/assistant-steps';
import {
  FormMultipleChoiceComponentConfig,
  FormMultipleChoiceValueType,
  StepDefinition,
} from '@/interfaces/step-definition';
import { AssistantStepContext } from '@/interfaces/context';
import { FormFieldType } from '@/consts/input-types';
import { FormFieldGroupId } from '~/consts/assistant-form-field-groups';

export interface CombiInterestStepContext extends AssistantStepContext {
  combiInterest: FormMultipleChoiceValueType;
}

const config: StepDefinition = {
  component,
  hideSkipMessage: () => true,
  fields: [
    {
      component: {
        columns: 3,
        // disableUnselect: true,
        hideCheckbox: true,
        options: [
          {
            value: 'pv',
            image: {
              file: 'img/icon/solar.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'heat-pump',
            image: {
              file: 'img/icon/heater-heat-pump.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'wallbox',
            image: {
              file: 'img/icon/wallbox.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
        ],
        singleAnswer: false,
        verticalOptionLayout: true,
      } as FormMultipleChoiceComponentConfig,
      name: 'combiInterest',
      required: true,
      type: FormFieldType.MultipleChoice,
      groupId: FormFieldGroupId.OBJECT,
    },
  ],
  id: StepId.COMBI_INTEREST,
  categoryId: StepCategoryId.COMBI,
};

export default config;
